/**
 * organization-email — the address tickets, receipts and invoices are sent
 * from. Settings and the onboarding stepper each mount it and each save it
 * their own way, so the field is controlled: the address comes down, every
 * edit goes up as `sender-change`. `platform-mail` marks the address as the
 * platform's own, which the organization cannot change until it connects
 * its own mail account.
 */
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { html, type TemplateResult } from "lit";
import { property } from "lit/decorators.js";
import { LocalizeMixin } from "../i18n/localize.ts";

@schmancyElement("organization-email")
export class OrganizationEmail extends LocalizeMixin(SchmancyElement) {
	@property() value = "";
	@property({ type: Boolean }) readonly = false;
	@property({ type: Boolean, attribute: "platform-mail" }) platformMail = false;

	override render(): TemplateResult {
		return html`
			<schmancy-input
				type="email"
				label=${this.t("admin.settings.organization.emailSender")}
				hint=${this.t(
					this.platformMail
						? "admin.settings.organization.emailSenderPlatformHint"
						: "admin.settings.organization.emailSenderHint",
				)}
				required
				?readonly=${this.readonly || this.platformMail}
				.errorMessages=${{
					valueMissing: this.t(
						"admin.settings.organization.requiredFieldMessage",
					),
					typeMismatch: this.t(
						"admin.settings.organization.emailValidationMessage",
					),
				}}
				.value=${this.value}
				@input=${(e: CustomEvent<{ value: string }>) =>
					this.dispatchEvent(
						new CustomEvent<string>("sender-change", {
							detail: e.detail.value,
						}),
					)}
			></schmancy-input>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"organization-email": OrganizationEmail;
	}
}
